module.exports = __webpack_public_path__ + "media/images/application/default/default-environnement-25dea06bf5c58a4e002a9fca5ebe60e2.jpg";